var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-simple-table',{attrs:{"dense":""},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('thead',[_c('tr',[_c('th',[_vm._v(_vm._s(_vm.$t("name")))]),_c('th',[_vm._v(_vm._s(_vm.$t("value")))])])]),_c('tbody',_vm._l((_vm.items),function(ref){
var key = ref.key;
var value = ref.value;
return _c('tr',{key:key},[_c('td',{staticClass:"key-column"},[_vm._v(_vm._s(key))]),_c('td',[_vm._v(_vm._s(value))])])}),0)]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }